import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { Flex, FlexColumn, DatePicker } from '~/shared/components';
import { DateFilterStandAloneProps } from '../types';

const Wrapper = styled(FlexColumn)`
  position: relative;
  min-width: 240px;
  margin-top: 6px;
`;

const DateWrapper = styled(Flex)`
  position: relative;
  min-width: 240px;
  margin-top: 12px;
  align-items: center;
  color: var(--filter-bar-date-icon-color);

  .MuiIconButton-root svg {
    fill: var(--filter-bar-date-icon-color);
    transition: fill 120ms ease;
  }

  .MuiIconButton-root:hover svg {
    fill: var(--filter-bar-date-icon-hover-fill);
  }
`;

const DateTitle = styled(Flex)`
  font-size: 13px;
  font-weight: 400;
  color: #4c5e72;
  pointer-events: none;
`;

const DateTextWrapper = styled(Flex)`
  color: inherit;
  font-size: 16px;
  font-weight: 500;
  pointer-events: none;
`;

const DatePickerWrapper = styled('div')`
  position: absolute;
  left: 50px;
`;

const DateFilterStandAlone = ({ name, value, onChange, dateType, options }: DateFilterStandAloneProps) => {
  const normalizedValue = Array.isArray(value) ? (value[0] ?? '') : (value ?? '');

  return (
    <Wrapper>
      <DateTitle>Formation and date</DateTitle>
      <DateWrapper>
        <DateTextWrapper>Date:</DateTextWrapper>
        <DatePickerWrapper>
          <DatePicker {...{ name, value: dayjs(normalizedValue), onChange, type: dateType, label: name, options }} />
        </DatePickerWrapper>
      </DateWrapper>
    </Wrapper>
  );
};

export default DateFilterStandAlone;
